@if (ultimasPrevisiones().length === 0) {
  <p>No hay datos disponibles</p>
} @else {
  <div class="container">
    <app-previsiones-table-readonly
      [previsiones]="ultimasPrevisiones()"
    ></app-previsiones-table-readonly>
  </div>
}
